import React, { Fragment, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Form, Spinner } from 'react-bootstrap';
import { trackPromise } from "react-promise-tracker";
import Swal from 'sweetalert2'
import { WebSocketContext } from "../../../../contexts/WebSocketContext";
import caAPI from "../../../../services/caAPI";
import './style.scss';
import moment from "moment";
import { InputMensagens } from '../../../../components/InputMensage';
import Templates from './templates';
import MensagemConteudoAtendimentoWhatsapp from '../../../../components/MensagemConteudoAtendimentoWhatsapp';
import InfiniteScroll from "react-infinite-scroll-component";
import { AtendimentoContext } from '../../../../contexts/AtendimentoContext';
import { TagDinamicaContext } from '../../../../contexts/TagDinamicaContext';
import ArquivoService from '../../../../services/ArquivosService';
import ModalDommus from '../../../../components/Modal';
import { FormAtribuirTagsDinamicas } from '../../../../components/FormAtribuirTagsDinamicas';
import { AtendentesContext } from '../../../../contexts/AtendentesContext';
import { PerfilUsuarioService } from '../../../../services/PerfilUsuarioService';
import CriarExemploAprendizado from '../CriarExemploAprendizado';

const templateMensagens = 'whatsapp';

export default function WhatsappComponent({ modoSelecao = false, onSairModoSelecao }) {

    const [mensagemInput, setMensagemInput] = useState('');
    const [iniciado, setIniciado] = useState(false);
    const [enviarTemplate, setEnviarTemplate] = useState(false);
    const [hasMore, setHasMore] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const messageContainerRef = useRef();
    const messagemOverflowRef = useRef();
    const [arquivos, setArquivos] = useState({});
    const [disabledInputMessage, setDisabledInputMessage] = useState(false);
    const {atendimentoAtivo, setLoadingMensagens, mensagensAtualizadasWhatsapp} = useContext(AtendimentoContext);
    const [listaMensagens, setListaMensagens] = useState(new Map());
    const { channel } = useContext(WebSocketContext);
    const [mensagemInicialFormatar, setMensagemInicialFormatar] = useState({});
    const [openModalTagDinamica, setOpenModalTagDinamica] = useState(false);
    const [podeEnviarAudio, setPodeEnviarAudio] = useState(false);
    const {checarPossuiTagsDinamicas} = useContext(TagDinamicaContext);
    const { validarUsuarioAtualAtendePorAtendimento } = useContext(AtendentesContext)
    const [idsSelecionados, setIdsSelecionados] = useState(new Set());
    const [openModalExemploAprendizado, setOpenModalExemploAprendizado] = useState(false);

    const extensoesPermitidasWhatsapp = ['jpg', 'jpeg', 'png', 'webp', 'ogg', 'amr', '3gp', 'aac', 'mpeg', 'mp3', 'pdf', 'doc', 'docx', 'pptx', 'xlsx', 'mp4', 'vcf'];

    useEffect(() => {
        PerfilUsuarioService.buscarDadosPerfil().then(res => {
            setPodeEnviarAudio(res.data?.data?.envia_audio ?? false);
        }).catch(() => {
            setPodeEnviarAudio(false);
        });
    }, []);

    // Sair do modo seleção (troca de atendimento ou desligar) limpa o que estava marcado.
    useEffect(() => {
        if (!modoSelecao) {
            setIdsSelecionados(new Set());
            setOpenModalExemploAprendizado(false);
        }
    }, [modoSelecao, atendimentoAtivo]);

    const alternarSelecaoMensagem = useCallback((idMensagem) => {
        setIdsSelecionados(selecionados => {
            const novos = new Set(selecionados);
            novos.has(idMensagem) ? novos.delete(idMensagem) : novos.add(idMensagem);
            return novos;
        });
    }, []);

    // Habilita "Continuar" só com ao menos uma mensagem de cada lado (lead e atendente).
    // Mídia conta pelo seu lado (direcao), igual a texto.
    const contagemSelecionadas = useMemo(() => {
        let recebido = 0;
        let enviado = 0;
        idsSelecionados.forEach(id => {
            const mensagem = listaMensagens.get(Number(id));
            if (!mensagem) return;
            if (mensagem.direcao === 'recebido') recebido += 1;
            else if (mensagem.direcao === 'enviado') enviado += 1;
        });
        return { recebido, enviado, total: recebido + enviado };
    }, [idsSelecionados, listaMensagens]);

    const podeContinuar = contagemSelecionadas.recebido >= 1 && contagemSelecionadas.enviado >= 1;

    function recebeMensagemInput(e) {
        setMensagemInput(e);
    }

    function recebeArquivo(e) {
        const arquivosArray = Array.isArray(e) ? e : [e];
        const arquivoInvalido = arquivosArray.find(arquivo => {
            const nomeArquivo = arquivo?.name ?? arquivo?.nome ?? '';
            const extensao = nomeArquivo.split('.').pop().toLowerCase();
            return !extensoesPermitidasWhatsapp.includes(extensao);
        });
        if (arquivoInvalido) {
            Swal.fire({
                titleText: "Arquivo não suportado",
                text: "Tipos permitidos no WhatsApp:\nImagens: JPG, JPEG, PNG, WEBP\nÁudio: OGG, AMR, 3GP, AAC, MPEG\nDocumentos: PDF, DOC, DOCX, PPTX, XLSX\nVídeo: MP4\nContatos: VCF",
                icon: 'error'
            });
            return;
        }
        setArquivos(e);
    }

    function parseMap(lista){
        let map = new Map();
        lista.map((item)=>{
           return map.set(Number(item?.id), item);
        })
        return map;
    }

    useEffect(() => {
        messagemOverflowRef.current.scrollTo(0,0);
    }, [atendimentoAtivo])


    useEffect(() => {
      setIniciado(false)
      setDisabledInputMessage(false);
      setEnviarTemplate(false);
      setListaMensagens(new Map());
      setHasMore(false);
      if(atendimentoAtivo){
        const novaLista = atendimentoAtivo.conteudos || [];
        const novoHasMore = atendimentoAtivo.hasMore;
        let horaAtual = moment();
        let novoDisabledInputMessage = true;
        let novoIniciado = false;
        let novoEnviarTemplate = false;
        if(novaLista.length > 0){
          novoIniciado = true;
          const ultimoConteudo = novaLista[novaLista.length - 1];
          const verificaMensagemRecebidaDentroDaJanela = (conteudo) => {
            let horaAtendimento = moment(conteudo.criado_em);
            return conteudo.direcao === "recebido" && (horaAtual.diff(horaAtendimento, "hours") < 24);
          }
          let detalhesUltimaMensagem = JSON.parse(ultimoConteudo.detalhes)
          let horaUltimaMensagemTemplate = moment(ultimoConteudo.criado_em);
          if (atendimentoAtivo.ultimo_recebido && verificaMensagemRecebidaDentroDaJanela(atendimentoAtivo.ultimo_recebido)) {
            novoDisabledInputMessage = false;
          }else if((atendimentoAtivo.situacao_atendimento && atendimentoAtivo.situacao_atendimento.tipo !== 'F') && !(detalhesUltimaMensagem.template && horaAtual.diff(horaUltimaMensagemTemplate, "hours") < 24)){
            novoEnviarTemplate = true;
          }
        }else{
          novoEnviarTemplate = true;
        }
        setIniciado(novoIniciado)
        if(!validarUsuarioAtualAtendePorAtendimento(atendimentoAtivo)) {
          novoDisabledInputMessage = true;
        }
        // Enquanto a IA atende, o input fica bloqueado para o atendente humano.
        // A fonte de verdade é o estado do atendimento, não o botão otimista do pai.
        novoDisabledInputMessage = novoDisabledInputMessage || !!atendimentoAtivo.atendimento_por_ia_ativado;
        setDisabledInputMessage(novoDisabledInputMessage);
        setEnviarTemplate(novoEnviarTemplate);
        setListaMensagens(parseMap(novaLista));
        setHasMore(novoHasMore);
        setCurrentPage(1);

      }
      return () => {
        setIniciado(false)
        setDisabledInputMessage(false);
        setEnviarTemplate(false);
        setListaMensagens(new Map());
        setHasMore(false);
      }
    }, [atendimentoAtivo, mensagensAtualizadasWhatsapp]);

    useEffect(() => {
        channel.unbind('whatsapp.' + atendimentoAtivo.id);
        channel.bind('whatsapp.' + atendimentoAtivo.id, function (data) {
          const newMessage = JSON.parse(data.mensagem);
          setListaMensagens(mensagens => new Map(mensagens).set(Number(newMessage?.id), newMessage));
          // Uma nova mensagem reabre a janela de 24h, mas não enquanto a IA atende.
          disabledInputMessage && !atendimentoAtivo.atendimento_por_ia_ativado && setDisabledInputMessage(false)
        });

        return () => {
          channel.unbind('whatsapp.' + atendimentoAtivo.id);
        }

    }, [channel, atendimentoAtivo, disabledInputMessage ])

    const enviarMensagem = useCallback(() => {
        if (!mensagemInput) {
            Swal.fire({
                titleText: "Atenção",
                text: "Escreva a mensagem antes de enviar",
                icon: 'warning'
            });
            return;
        }
        trackPromise(
            caAPI.atendimento.whatsapp.enviar({ id_atendimento: atendimentoAtivo.id, body: mensagemInput }).then(res => {
              const novaMensagem = (res.data.conteudos.pop());
              setListaMensagens(messages => new Map(messages).set(Number(novaMensagem.id), novaMensagem));
            }).catch(e => {
                Swal.fire({
                    titleText: "Erro",
                    text: "Houve um problema ao enviar a mensagem " + e,
                    icon: 'error'
                });
            })
        )
        setMensagemInput('');
    }, [atendimentoAtivo, mensagemInput]);

    const enviarImagem = useCallback((arquivosGaleria=null) => {
        const arquivosEnviar = arquivosGaleria || arquivos
        if (!arquivosEnviar?.length) {
            Swal.fire({
                titleText: "Atenção",
                text: "Nenhuma imagem selecionada",
                icon: 'warning'
            });
            return;
        }
        const  resolverPayloads = async function (arquivosEnviar) {
            let payloads = [];
            for(const arquivo of arquivosEnviar){
                let payload = {
                    id_atendimento: atendimentoAtivo.id,
                    body: mensagemInput
                };

                payload.nome_arquivo = arquivo.nome ?? arquivo.name ? arquivo.name : null;
                if(arquivo.extensao){
                    payload.extensao = arquivo.extensao;
                }
                if(arquivosGaleria && arquivo?.link) {
                    payload.url_media = arquivo.link;
                    payload.tipo = arquivo.extensao;
                    payload.body = arquivo.nome || null;
                } else {
                    payload.arquivo = arquivo.conteudo
                    payload.tipo = arquivo.tipo ?? arquivo.type ?? null
                
                }
                
                if(Object.prototype.toString.call(arquivo) === "[object Blob]"){
                    try {
                        payload.arquivo = await ArquivoService.converterBlobParaBase64(arquivo);    
                        payloads.push(payload);   
                    } catch (error) {
                        console.error("Erro ao converter o arquivo:", error);
                    }
                }else{
                    payloads.push(payload);        
                }
            }
            return payloads
        };
        trackPromise(resolverPayloads(arquivosEnviar).then(async (payloads) => {
            const aguardar = (ms) => new Promise(resolve => setTimeout(resolve, ms));
            const novaLista = new Map(listaMensagens);
            try {
                for (let i = 0; i < payloads.length; i++) {
                    if (i > 0) {
                        await aguardar(200);
                    }
                    const res = await enviarArquivo(payloads[i]);
                    const novaMensagem = res?.data?.conteudos[0];
                    if (novaMensagem?.id && !novaLista.has(novaMensagem.id)) {
                        novaLista.set(Number(novaMensagem.id), novaMensagem);
                    }
                }
                setListaMensagens(novaLista);
                setMensagemInput('');
                setArquivos("");
            } catch (e) {
                Swal.fire({
                    titleText: "Erro",
                    text: "Houve um problema ao enviar a mensagem " + e,
                    icon: 'error'
                });
                setMensagemInput('');
                setArquivos("");
            }
        }));
        
       
    }, [atendimentoAtivo, arquivos]);

    const enviarArquivo = (payload) => {        
        return caAPI.atendimento.whatsapp.enviar(payload);
    }

    const enviarAudio = useCallback((base64, mimeType) => {
        const timestamp = Date.now();
        const payload = {
            id_atendimento: atendimentoAtivo.id,
            arquivo: base64,
            tipo: mimeType,
            nome_arquivo: `${caAPI.getLocalState('idUsuario')}_${atendimentoAtivo.id}_${timestamp}.ogg`,
            audio: true
        };
        trackPromise(
            caAPI.atendimento.whatsapp.enviar(payload).then(res => {
                const novaMensagem = res?.data?.conteudos?.[0];
                if (novaMensagem?.id) {
                    setListaMensagens(mensagens => new Map(mensagens).set(Number(novaMensagem.id), novaMensagem));
                }
            }).catch(e => {
                Swal.fire({
                    titleText: 'Erro',
                    text: 'Houve um problema ao enviar o áudio ' + e,
                    icon: 'error'
                });
            })
        );
    }, [atendimentoAtivo]);
    
    function recebeMensagemInicial(mensagemInicial) {
      if(checarPossuiTagsDinamicas(mensagemInicial.mensagem)){
        setMensagemInicialFormatar(mensagemInicial);
        setOpenModalTagDinamica(true);
      }else{
        enviarMensagemTemplate(mensagemInicial);
      }
    }

    function enviarMensagemTemplate(mensagemInicial){
        trackPromise(
          caAPI.atendimento.whatsapp.enviar({ id_atendimento: atendimentoAtivo.id, body: mensagemInicial.mensagem, template: true, id_template:mensagemInicial.id_template, tags: mensagemInicial?.tags ?? []}).then(res => {
            const novaMensagem = res.data.conteudos.pop();
            setListaMensagens(menssages => new Map(menssages).set(Number(novaMensagem.id), novaMensagem));
            setIniciado(true);
            setEnviarTemplate(false);
          })).catch(err => {
              console.log(err)
              console.log(err.response)
              if(err.response?.status == 422) {
                  Swal.fire('Ooops...', err.response?.data?.message, 'warning')

                  return
              }
              Swal.fire({
                  titleText: "Erro",
                  text: "Ocorreu um problema ao iniciar o atendimento.",
                  icon: 'error'
              });
        })
    }

    const changeSubmitKey = useCallback(e => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            enviarMensagem();
        }
    }, [enviarMensagem]);

    const scrollDown = function () {
        messageContainerRef.current.scrollIntoView({ behavior: 'smooth' });
    };

    const mensagens = useMemo(() => {
        if (listaMensagens) {
            let listIterar = Array.from(listaMensagens.values()).filter(msg => msg && msg?.detalhes).reverse();
            let date = moment().format('DD/MM/YYYY');;
            setLoadingMensagens(false);
            return listIterar.map((msg, indice) => {
                let isLast = (indice === (listIterar.length - 1));
                let separator = false;
                let separatorLast = false;

                let msg_date = moment(msg.criado_em).format('DD/MM/YYYY');
                if ((date !== msg_date)) {
                    separator = <div className="separador">{date}</div>;
                    date = msg_date;
                }
                if(isLast){
                  separatorLast = <div className="separador">{msg_date}</div>;
                }
                return <Fragment key={msg.id}>
                  {separator}
                  {modoSelecao ? (
                    <div className={`mensagem-selecionavel ${msg.direcao === 'recebido' ? 'recebida' : 'enviada'}`}>
                      <Form.Check
                        type="checkbox"
                        id={`selecionar-mensagem-${msg.id}`}
                        className="check-selecionar-mensagem"
                        checked={idsSelecionados.has(Number(msg.id))}
                        onChange={() => alternarSelecaoMensagem(Number(msg.id))}
                      />
                      <div className="mensagem-selecionavel-conteudo">
                        <MensagemConteudoAtendimentoWhatsapp conteudo={msg} />
                      </div>
                    </div>
                  ) : (
                    <MensagemConteudoAtendimentoWhatsapp conteudo={msg} />
                  )}
                  {separatorLast}
                </Fragment>
            });
        }

        scrollDown()
    }, [listaMensagens, modoSelecao, idsSelecionados, alternarSelecaoMensagem]);

    const handleLoadMoreMessages = () => {
        setLoadingMensagens(true);
        caAPI.atendimento.getMessages(atendimentoAtivo.id, Number(currentPage) + 1).then(res => {
            setCurrentPage(currentPage + 1)
            let contatenado = new Map([...(parseMap(res.data.conteudos))].concat([...listaMensagens]))
            setListaMensagens(contatenado);
            setHasMore(res.data.hasMore);
            setLoadingMensagens(false);
        }).catch(err => {
            Swal.fire({
                titleText: "Erro",
                text: "Houve um problema ao buscar mais mensagens",
                icon: 'error'
            });
            return;
        });

    };

    useEffect(() => {
      if(mensagensAtualizadasWhatsapp){
        const mensagensInserir = mensagensAtualizadasWhatsapp.filter(mensagem => mensagem && mensagem.id_atendimento == atendimentoAtivo.id);
        if(mensagensInserir.length){
          const novoMensagens = Array.from(listaMensagens.values()).concat(mensagensInserir);
          novoMensagens.sort((mensagemA, mensagemB) => {
            return Date(mensagemA.criado_em) < Date(mensagemB.criado_em) ? -1 : 1;
          });
          setListaMensagens(parseMap(novoMensagens));
        }
      }
    }, [mensagensAtualizadasWhatsapp])

    return (
        <>
            <div className="whatsapp-container" id="scrollableDiv" ref={messagemOverflowRef} >
            { enviarTemplate &&
              <>
                  <Templates recebeMensagemInicial={recebeMensagemInicial}/>
              </>
            }
                {iniciado &&
                    <>
                        <InfiniteScroll
                            useWindow={false}
                            className="whatsapp-container"
                            style={{ display: 'flex', flexDirection: 'column-reverse' }}
                            dataLength={mensagens.length}
                            next={handleLoadMoreMessages}
                            hasMore={hasMore}
                            inverse={true}
                            loader={<Spinner animation="border" style={{ color: '#265d9c' }} />}
                            endMessage={
                                <p style={{ textAlign: 'center' }}>
                                    <b>Fim das Mensagens</b>
                                </p>
                            }
                            // below props only if you need pull down functionality
                            refreshFunction={() => { }}
                            pullDownToRefresh
                            pullDownToRefreshThreshold={50}
                            scrollableTarget="scrollableDiv"

                        >
                            {mensagens}
                        </InfiniteScroll>
                    </>
                  }

            </div>
            <div ref={messageContainerRef} />
            {modoSelecao &&
              <div className="barra-selecao-aprendizado" id="barra-selecao-aprendizado">
                <div className="barra-selecao-aprendizado-info">
                  <span className="contador-selecao" id="contador-mensagens-selecionadas">
                    {contagemSelecionadas.total} {contagemSelecionadas.total === 1 ? 'mensagem selecionada' : 'mensagens selecionadas'}
                  </span>
                  {!podeContinuar &&
                    <span className="dica-selecao text-muted">
                      Selecione ao menos uma mensagem recebida e uma enviada.
                    </span>
                  }
                </div>
                <div className="barra-selecao-aprendizado-acoes">
                  <button
                    type="button"
                    className="btn btn-secondary btn-cancelar-selecao"
                    id="cancelar-selecao-aprendizado"
                    onClick={() => onSairModoSelecao && onSairModoSelecao()}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-continuar-selecao"
                    id="continuar-selecao-aprendizado"
                    disabled={!podeContinuar}
                    onClick={() => setOpenModalExemploAprendizado(true)}
                  >
                    Continuar
                  </button>
                </div>
              </div>
            }
            <div className='mensagem-textarea'>
                {(!modoSelecao && iniciado && !(enviarTemplate) && (atendimentoAtivo.situacao_atendimento && atendimentoAtivo.situacao_atendimento.tipo !== 'F')) &&
                    <InputMensagens
                        disabledInputMessage={disabledInputMessage}
                        disabledEmoticons={disabledInputMessage}
                        disabledAnexos={disabledInputMessage}
                        disabledAnotacoes={disabledInputMessage}
                        disabledMenu={false}
                        templateMensagens={templateMensagens}
                        mensagemInput={mensagemInput}
                        setLegendaInput={setMensagemInput}
                        recebeArquivo={recebeArquivo}
                        enviarImagem={enviarImagem}
                        enviarMensagem={enviarMensagem}
                        receberMensagemInicial={recebeMensagemInicial}
                        atendimento={atendimentoAtivo}
                        recebeMensagemInput={recebeMensagemInput}
                        changeSubmitKey={changeSubmitKey}
                        applyRule={false}
                        gravarAudio={podeEnviarAudio}
                        enviarAudio={enviarAudio}/>
                }
            </div>
            <ModalDommus
              open={openModalTagDinamica}
              close={() => {
                setOpenModalTagDinamica(false);
              }}
              size="md"
              titulo="Tags Dinâmicas"
            >
              <FormAtribuirTagsDinamicas mensagemInicialFormatar={mensagemInicialFormatar} enviarMensagemTemplate={enviarMensagemTemplate} closeModal={()=>setOpenModalTagDinamica(false)}/>
            </ModalDommus>
            <CriarExemploAprendizado
              aberto={openModalExemploAprendizado}
              close={() => setOpenModalExemploAprendizado(false)}
              idAtendimento={atendimentoAtivo.id}
              idsMensagens={Array.from(idsSelecionados)}
              onEnviado={() => {
                setOpenModalExemploAprendizado(false);
                onSairModoSelecao && onSairModoSelecao();
              }}
            />
        </>
    );
}
